module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Bold.449e6f45.eot";